function parseCashAmount(value) {
  if (value == null) return NaN;
  const raw = String(value).trim().replace(/,/g, '').replace(/=/g, '');
  if (!raw) return NaN;
  const thousands = raw.match(/^(-?\d+(?:\.\d+)?)k$/i);
  if (thousands) return parseFloat(thousands[1]) * 1000;
  const amount = parseFloat(raw.replace(/[^0-9.-]/g, ''));
  return Number.isFinite(amount) ? amount : NaN;
}

function roundHalfAwayFromZero(amount) {
  const sign = amount < 0 ? -1 : 1;
  return sign * Math.round(Math.abs(amount));
}

const wholeDollarFormat = new Intl.NumberFormat('en-US', {
  maximumFractionDigits: 0,
  minimumFractionDigits: 0,
});

function cashAmountFieldText(storedValue, editing) {
  if (editing) return storedValue == null ? '' : String(storedValue);
  const amount = parseCashAmount(storedValue);
  if (!Number.isFinite(amount)) return '0';
  return wholeDollarFormat.format(roundHalfAwayFromZero(amount));
}

module.exports = { cashAmountFieldText };
